import { Scene, OrthographicCamera, AmbientLight, DirectionalLight, MOUSE, Group } from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';

export class SceneGroupConfig {
	constructor(){
		this.scene = null;
	}

	init( sceneUnit ) {
		// init scene
		this.#initScene( sceneUnit );

		// init camera
		this.#initCamera( sceneUnit );

		// init controls
		this.#initControls( sceneUnit );		

		// init lights
		this.#initLights( sceneUnit );
	}

	#initScene( sceneUnit ) {
		if( sceneUnit.scene ) 
			sceneUnit.scene.clear();

		sceneUnit.scene = new Scene();
		sceneUnit.scene.name = 'SCENE_GROUP';
	}

	#initCamera( sceneUnit ) {
		if( !sceneUnit.camera ) {

			const size = 100; //in threeJS units
			
			//canvas size and aspect ratio
			const canvasSize = sceneUnit.container.getBoundingClientRect();
			const aspect = canvasSize.width / canvasSize.height;

			sceneUnit.camera = new OrthographicCamera( -size * aspect , size * aspect , size, -size, -size/2, 10*size );
		}
		sceneUnit.camera.position.set( 0, 100, 0 );
		sceneUnit.camera.updateProjectionMatrix();
	}

	#initControls( sceneUnit ) {
		if( !sceneUnit.controls )
			sceneUnit.controls = new OrbitControls( sceneUnit.camera, document.querySelector( 'canvas' ) ); 
		sceneUnit.controls.enabled = true;
		sceneUnit.controls.enableRotate = false;
		sceneUnit.controls.enablePan = true;
		sceneUnit.controls.enableZoom = true;
		sceneUnit.controls.mouseButtons = {
			LEFT: MOUSE.ROTATE,
			MIDDLE: MOUSE.DOLLY,
			RIGHT: MOUSE.PAN
		};
		sceneUnit.controls.enableDamping = false;
		sceneUnit.controls.target.set( 0, 0, 0 );
		sceneUnit.controls.update();

		//Looks counter intuitive, but minZoom controls how much you can zoom out, and maxZoom how much you can zoom in
		sceneUnit.controls.minZoom = 0.05;
		sceneUnit.controls.maxZoom = 15;

		// get change event
		sceneUnit.controls.addEventListener( 'change', () => {
			sceneUnit.moveCutDeleteButtons();
		});
	}

	#initLights( sceneUnit ) {
		sceneUnit.scene.add( new AmbientLight( 0xffffff, 1 ) );
		const light = new DirectionalLight( 0xffffff, 1 );
		light.position.set( 100, 0.5, 100 );
		sceneUnit.scene.add( light );

		//shadow
		light.castShadow = true;
		light.shadow.mapSize.width = 1024;
		light.shadow.mapSize.height = 1024;
		light.shadow.camera.near = 0.5;
		light.shadow.camera.far = 500;
	}

}

export class ContornoGroup extends Group { constructor() { super(); this.name = 'CONTORNO_GROUP'; } }
export class FrontalesGroup extends Group { constructor() { super(); this.name = 'FRONTALES_GROUP'; } }
export class LateralesGroup extends Group { constructor() { super(); this.name = 'LATERALES_GROUP'; } }
export class CapillasGroup extends Group { constructor() { super(); this.name = 'CAPILLAS_GROUP'; } }
export class TraversalesGroup extends Group { constructor() { super(); this.name = 'TRAVERSALES_GROUP'; } }